// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": "#ffffff",
	"primaryLight": "#ebf7fa",
	"primary200": "#68c2d9",
	"primaryMain": "#3fb2cf",
	"primaryDark": "#318aa1",
	"primary800": "#236273",
	"secondaryLight": "#ebf7fa",
	"secondary200": "#68c2d9",
	"secondaryMain": "#3fb2cf",
	"secondaryDark": "#318aa1",
	"secondary800": "#236273",
	"successLight": "#ccffe4",
	"success200": "#00c05a",
	"successMain": "#008D42",
	"successDark": "#006d33",
	"errorLight": "#ffe5e5",
	"errorMain": "#FF2E2E",
	"errorDark": "#c62323",
	"orangeLight": "#fbe9e7",
	"orangeMain": "#ffab91",
	"orangeDark": "#d84315",
	"warningLight": "#fff8e1",
	"warningMain": "#ffe57f",
	"warningDark": "#ffc107",
	"grey50": "#fafafa",
	"grey100": "#f5f5f5",
	"grey200": "#eeeeee",
	"grey300": "#e0e0e0",
	"grey500": "#9e9e9e",
	"grey600": "#757575",
	"grey700": "#616161",
	"grey900": "#212121"
};
export default ___CSS_LOADER_EXPORT___;
